import * as React from "react"

const ChevronRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M10.7 8 7 11.7l-.7-.7 3-3-3-3 .7-.7L10.7 8Z" />
  </svg>
)

export default ChevronRight
